import { InteractionObjectType } from "../../../constants";
import { addOrRemoveObjectInteractions } from "../../../service/interaction";
import { ServiceError, Status } from "../../../service/Shared";
import { InteractionTag } from "../../TagsPanel/models";

/*
  Links the tags carried in a panel onto a transaction that has just been created, returning the errors rather
  than reporting them: the transaction is already persisted by this point, so only the caller knows whether the
  failure closes the panel, opens a follow-on modal, or is one of several rows in a bulk create.

  Returns undefined when there was nothing to link or the link succeeded, matching useObjectAttachments'
  saveAttachments so both side-effects can be checked the same way.
*/
export const saveTransactionTags = async (
  transactionUuid: string,
  tags: InteractionTag[]
): Promise<ServiceError[] | undefined> => {
  const objectInteractions = tags
    .filter((tag) => tag.checked)
    .map((tag) => ({
      interactionUuid: tag.uuid,
      objectType: InteractionObjectType.ISSUANCE_TRANSACTION,
      objectUuid: transactionUuid,
      operation: "add",
    }));

  if (objectInteractions.length === 0) return undefined;

  /*
    addOrRemoveObjectInteractions turns a transport failure into Status.Error rather than throwing, so reading
    the status is the only way to detect one — a try/catch here would never fire.
  */
  const res = await addOrRemoveObjectInteractions({ objectInteractions });

  if (res.status !== Status.Error) return undefined;

  /*
    errors is optional on BaseResponse, and a failure the store did not explain still has to be reported —
    so the array handed back is never empty, and callers can read errors[0] without guarding.
  */
  return res.errors?.length ? res.errors : [{ code: "unknown", message: "The tags could not be linked." }];
};
